import { LoaderIcon, ScanBarcodeIcon, SmartphoneIcon } from "lucide-react";
import PaymentInstruction from "../PaymentInstruction";

const PixInstructions = () => {
  return (
    <div className="flex flex-col gap-6" data-testid="pix_instructions">
      <p className="text-xl font-bold">
        Como pagar meu pix?
      </p>

      <div className="flex flex-col gap-4">
        <PaymentInstruction
          Icon={SmartphoneIcon}
          text="Utilize o aplicativo do seu banco copiando o código PIX ou escaneando o QR-Code."
        />

        <PaymentInstruction
          Icon={ScanBarcodeIcon}
          text="Confirme os dados de pagamento e o valor do seu pedido."
        />

        <PaymentInstruction
          Icon={LoaderIcon}
          text="Seu pagamento será processado e quando aprovado o saldo constará em sua conta Tcard."
        />
      </div>
    </div>
  );
}

export default PixInstructions;
